export const socialsData = {
    github: 'https://github.com/manav4245',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/manav-m-171378205/',
    instagram: 'https://www.instagram.com/flyinghigh_technologies/',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: '',
    stackOverflow: 'https://stackoverflow.com/users/16526158/manav',
    gitlab: '',
    youtube: ''
}